<template>
    <el-dialog title="增加积分" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <!-- <el-form label-position="top" label-width="100px" ref="form" :model="form"> -->
        <el-form label-width="60px" ref="form" :model="form">
            <el-form-item label="积分:">
                <el-input v-model.trim="form.points" oninput="value=value.replace(/[^0-9]/g,'')" placeholder="请输入增加的积分"></el-input>
            </el-form-item>
        </el-form>
        <div class="add-points-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" :loading="loading" @click="onSubmit">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import serverApi from '../../../server/index';
export default {
    props: ['dialogVisible','userInfo'],
    data() {
        return {
            form: {
                points: '',
            },
            loading: false,
        };
    },
    methods: {
        onSubmit() {
            this.loading = true;
            const params = {
                points: Number(this.form.points),
                uid: this.userInfo.uid
            };
            serverApi
                .user_add_point(params)
                .then(res => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: 'Add success',
                            type: 'success',
                        });
                        this.$emit('closeModal', true);
                    } else {
                        this.$message({
                            message: res.data.msg || res.data.error,
                            type: 'error',
                        });
                    }
                })
                .catch(e => {
                    this.$message({
                        message: e.data.error || e.data.msg,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleClose() {
            this.$emit('closeModal', false);
        },
    },
};
</script>

<style lang="scss">
.add-points-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
}
</style>
